export interface ClassRegisterUserPreferenceModulePatchPayload {
  classbook: Partial<ClassRegisterPrefs>;
}

export interface GeneralUserPreferenceModulePatchPayload {
  general: Partial<GeneralPreferences>;
}

export interface ClassRegisterUserPreferenceSettingsPatchPayload {
  classbook: OnePropertyOf<ClassRegisterPrefs>;
  settingsKey: keyof ClassRegisterPrefs;
}
export interface GeneralUserPreferenceSettingsPatchPayload {
  general: OnePropertyOf<GeneralPreferences>;
  settingsKey: keyof GeneralPreferences;
}
export interface ClassRegisterPrefs {
  absencesOverview: ListPresentation;
}

export interface CoursesPrefs {
  showMyHomework: boolean;
}

export interface GeneralPreferences {
  userListSorting: UserListSorting;
  language: string;
  theme: string;
}
export interface GeneralUserListSortingPreference {
  userListSorting: Partial<GeneralPreferences>;
}
export enum ListPresentation {
  List = 'List',
  Grid = 'Grid',
}

export enum UserListSorting {
  FirstName = 'firstName',
  LastName = 'lastName',
  DisplayName = 'displayName',
}
export enum UserPreferencesModules {
  General = 'General',
  Absences = 'Absences',
  Announcements = 'Announcements',
  Assignments = 'Assignments',
  Bildungslogin = 'Bildungslogin',
  Calendar = 'Calendar',
  Classbook = 'Classbook',
  Courses = 'Courses',
  DeviceManagement = 'DeviceManagement',
  DeviceSettings = 'DeviceSettings',
  Emails = 'Emails',
  Files = 'Files',
  Groups = 'Groups',
  GroupTemplates = 'GroupTemplates',
  ModuleRights = 'ModuleRights',
  Organization = 'Organization',
  Passwords = 'Passwords',
  Reports = 'Reports',
  Resources = 'Resources',
  SchoolLinks = 'SchoolLinks',
  Settings = 'Settings',
  Timetable = 'Timetable',
  Users = 'Users',
  UserTemplates = 'UserTemplates',
  Webinars = 'Webinars',
  Workgroups = 'Workgroups',
}
type NoneOf<T> = {
  [K in keyof T]?: never;
};
export type OnePropertyOf<T> = {
  [K in keyof T]: Omit<NoneOf<T>, K> & {
    [P in K]: T[P];
  };
}[keyof T];
